<template>
  <!--  Mobile grid-->
  <ModularCardsGrid
    v-if="layout === 'grid'"
    v-bind="propsWithoutLayout"
    class="flex md:hidden"
  />
  <!--  Desktop grid-->
  <ModularCardsGrid
    v-if="desktopLayout === 'grid'"
    v-bind="propsWithoutLayout"
    class="hidden md:flex"
  />

  <!--  Mobile carousel-->
  <ModularCardsCarousel
    v-if="layout === 'carousel'"
    v-bind="propsWithoutLayout"
    class="flex md:hidden"
  />
  <!--  Desktop carousel-->
  <ModularCardsCarousel
    v-if="desktopLayout === 'carousel'"
    v-bind="propsWithoutLayout"
    class="hidden md:flex"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { ModularCardsCarouselProps } from '@backmarket/http-api/src/api-specs-content/models/modular-card'

import type { ContentBlockProps } from '../../models/content-block'

import ModularCardsCarousel from './ModularCardsCarousel.vue'
import ModularCardsGrid from './ModularCardsGrid.vue'

const props = withDefaults(
  defineProps<ModularCardsCarouselProps & ContentBlockProps>(),
  {
    cardsHavePadding: true,
    layout: 'carousel',
    desktopLayout: 'carousel',
  },
)

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])

const propsWithoutLayout = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { layout, desktopLayout, ...rest } = props

  return rest
})
</script>
